var map = {
	"./af.json": 834,
	"./am.json": 835,
	"./ar.json": 836,
	"./az.json": 837,
	"./be.json": 838,
	"./bg.json": 839,
	"./bn.json": 840,
	"./bs.json": 841,
	"./ca.json": 842,
	"./cs.json": 843,
	"./cy.json": 844,
	"./da.json": 845,
	"./de.json": 846,
	"./dv.json": 847,
	"./el.json": 848,
	"./en.json": 849,
	"./es.json": 850,
	"./et.json": 851,
	"./eu.json": 852,
	"./fa.json": 853,
	"./fi.json": 854,
	"./fr.json": 855,
	"./gl.json": 856,
	"./ha.json": 857,
	"./he.json": 858,
	"./hi.json": 859,
	"./hr.json": 860,
	"./hu.json": 861,
	"./hy.json": 862,
	"./id.json": 863,
	"./is.json": 864,
	"./it.json": 865,
	"./ja.json": 866,
	"./ka.json": 867,
	"./kk.json": 868,
	"./km.json": 869,
	"./ko.json": 870,
	"./ku.json": 871,
	"./ky.json": 872,
	"./lt.json": 873,
	"./lv.json": 874,
	"./mk.json": 875,
	"./ml.json": 876,
	"./mn.json": 877,
	"./ms.json": 878,
	"./nb.json": 879,
	"./nl.json": 880,
	"./nn.json": 881,
	"./no.json": 882,
	"./pl.json": 883,
	"./ps.json": 884,
	"./pt.json": 885,
	"./ro.json": 886,
	"./ru.json": 887,
	"./sd.json": 888,
	"./sk.json": 889,
	"./sl.json": 890,
	"./so.json": 891,
	"./sq.json": 892,
	"./sr.json": 893,
	"./sv.json": 894,
	"./sw.json": 895,
	"./ta.json": 896,
	"./tg.json": 897,
	"./th.json": 898,
	"./tr.json": 899,
	"./tt.json": 900,
	"./ug.json": 901,
	"./uk.json": 902,
	"./ur.json": 903,
	"./uz.json": 904,
	"./vi.json": 905,
	"./zh.json": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 833;